module.exports = __webpack_public_path__ + "static/media/IMG-1.19e8f5b8.jpg";